import { LanguageState, LanguageActionTypes, LanguageTypes, LanguageActions } from "./types";
import translations from "constants/translations.json";

// Initial state
const initialState: LanguageState = {
  language: navigator.language.startsWith("de") ? "de" : "en",
  supportedLangs: getSupportedLanguages(),
};

function getSupportedLanguages() {
  return Object.keys(translations).map((d: string) => {
    return {
      name: d as LanguageTypes,
      text: translations[d as LanguageTypes].name,
    };
  });
}

// The reducer function
export function languageReducer(state = initialState, action: LanguageActions): LanguageState {
  switch (action.type) {
    case LanguageActionTypes.SET_LANGUAGE: {
      return { ...state, language: action.payload };
    }
    default: {
      return state;
    }
  }
}
